// MODEL : Report
//
define('app/dashboard/widgets/KpiReportDashboardItemView',['require','./ReportDashboardItemView','hbs!./KpiReportDashboardItemView.hbs'],function(require) {

	'use strict';

	var ReportDashboardItemView = require('./ReportDashboardItemView');

	return ReportDashboardItemView.extend({
		className: 'dashboard-item dashboard-item-kpi-report',
		template: require('hbs!./KpiReportDashboardItemView.hbs'),

		initialize: function() {
			// call base class initialize function
			ReportDashboardItemView.prototype.initialize.call(this);

			this.model.set('isLoading', true);
			this.listenTo(this.model, 'dataReceived', this.dataReceived);
			this.listenTo(this.model, 'change', this.render);
		},

		ui: {
			$kpiValue: '.kpi-value > span',
			$kpiContainer: '.kpi-value'
		},

		dataReceived: function() {
			this.model.set('isLoading', false);
			this.render();
			this.textFill();
		},

		isLoading: function() {
			return this.model.get('isLoading');
		},

		kpiValue: function() {
			return this.model.consumableResults().kpi().toString() || 0;
		},

		hasKpi: function() {
			return this.model.hasKpi();
		},

		textFill: function() {
			if (!this.ui.$kpiValue || !this.ui.$kpiContainer) {
				return;
			}

			var ourText = this.ui.$kpiValue;
			var fontSize = parseInt(ourText.css('font-size'), 10);
			var maxWidth = 186;
			var textWidth;
			do {
				ourText.css('font-size', fontSize);
				textWidth = ourText.width();
				fontSize = fontSize - 1;
			} while (textWidth > maxWidth && fontSize > 3);
		}

	});
});

